var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form-row",
    [
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-form-checkbox",
            {
              staticClass: "pb-1",
              model: {
                value: _vm.model.render,
                callback: function ($$v) {
                  _vm.$set(_vm.model, "render", $$v)
                },
                expression: "model.render",
              },
            },
            [_vm._v("\n      Wrap\n    ")]
          ),
          _vm._v(" "),
          _vm.model.render
            ? _c(
                "div",
                { staticClass: "ml-2" },
                [
                  _c(
                    "b-form-checkbox",
                    {
                      model: {
                        value: _vm.model.showGrid,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "showGrid", $$v)
                        },
                        expression: "model.showGrid",
                      },
                    },
                    [_vm._v("\n        Show grid\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-checkbox",
                    {
                      model: {
                        value: _vm.model.editing,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "editing", $$v)
                        },
                        expression: "model.editing",
                      },
                    },
                    [_vm._v("\n        Edit\n      ")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }